export const ENTITY = 'AI_SEARCH';
export const ENTITY_PAIRS = 'AI_SEARCH_PAIRS';
